<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">Cambiar contraseña</h3>
      </div>
    </v-card-title>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-text-field v-model="formData.currentPassword" label="Contraseña Actual" placeholder="Contraseña" type="password" :rules="[rules.currentPassword]" :error="(rules.currentPassword ? true : false)" ></v-text-field>
        </v-flex>
        <v-flex sm12>
          <v-text-field v-model="formData.newPassword" label="Nueva contraseña" placeholder="Nueva contraseña" type="password" :rules="[rules.newPassword]" :error="(rules.newPassword ? true : false)"></v-text-field>
        </v-flex>
        <v-flex sm12>
          <v-text-field v-model="formData.newPassword_confirmation" label="Repetir nueva contraseña" placeholder="Nueva Contraseña" type="password"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
        <v-btn flat color="primary" @click="submitForm">Cambiar contraseña</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
  import axios from 'axios';
  export default {
    data: () => ({
      formData: {
        currentPassword : null,
        newPassword : null,
        newPassword_confirmation : null
      },
      rules: {
        currentPassword : false,
        newPassword : false,
      },
    }),
    mounted () {
      axios.defaults.headers.post['Accept'] = 'application/json';
      axios.defaults.baseURL = 'https://auth.asistenciamobile.cl/api/';
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    },
    methods: {
      submitForm(){
        let $this = this;
        axios.post( '/admin/changePasswordAccount', this.formData )
             .then( function(response){
               window.getApp.$emit('APP_RESOURCE_UPDATED', 'Contraseña actualizada.');
               window.getApp.$emit('APP_LOGOUT');
             })
             .catch(error => {
               if(error.response.status == 422){
                 for(let atr in $this.rules){
                   $this.rules[atr] = (error.response.data.errors.hasOwnProperty(atr) ? error.response.data.errors[atr] : false); //recorre las reglas y las compara con el resultado devuelgo por laravel
                 }
               }
             })
             .finally(function () {

             });
      }
    }
  }
</script>
